/**
 * FE-safe static projections — no draft runtime / no node:fs pull into Vite bundle.
 */
import type {
  BuilderDraftSuggestionViewV1,
  TodayAiAttentionCardV1,
  WorkbenchControlledLaneViewV1,
} from './surfaceProjectionsV1';

export function feSafeTodayAiAttentionCardV1(): TodayAiAttentionCardV1 {
  return {
    whyAttention: 'OperationComposition draft may benefit from a reversible AI naming suggestion',
    whatObserved: 'Draft task "Confirm arrival" on PROCURE_TO_RECEIVE SIMPLE',
    whatProposed: 'AI draft suggestion: rename task task_confirm_arrival',
    riskAuthorityState: 'LOW / ALLOW',
    approvalRequirement: 'satisfied',
    executionState: 'EXECUTED',
    uiState: 'executed',
    grantsAuthority: false,
    distinctions: {
      aiNarrativeIsNotSystemTruth: true,
      proposalIsNotApproved: true,
      approvedIsNotExecuted: true,
      executedIsNotReconciled: true,
      receiptIsNotAiSummary: true,
      retryConversationIsNotRetryMutation: true,
    },
  };
}

export function feSafeWorkbenchControlledLaneViewV1(): WorkbenchControlledLaneViewV1 {
  return {
    flowPurpose: 'PROCURE_TO_RECEIVE',
    sources: [
      { ref: 'flowPurpose:PROCURE_TO_RECEIVE', class: 'canonical_fact' },
      { ref: 'draft:demo', class: 'draft_configuration' },
    ],
    factsVsAssumptions: {
      facts: ['FlowPurpose PROCURE_TO_RECEIVE', 'Draft unpublished'],
      assumptions: ['operator will review before save', 'publish remains separate'],
    },
    proposalDetails: 'AI draft suggestion: rename task task_confirm_arrival',
    expectedEffect:
      'tasks.task_confirm_arrival.name: Confirm arrival → Confirm arrival (AI draft suggestion)',
    authorityDecision: 'ALLOW',
    approvalStatus: 'APPROVED',
    executionStatus: 'EXECUTED',
    receiptId: 'receipt_exec_idem_prop_draft_rename_v1',
    recovery: null,
    provenance: 'PROPOSAL',
    uiState: 'executed',
    grantsAuthority: false,
  };
}

export function feSafeBuilderDraftSuggestionViewV1(): BuilderDraftSuggestionViewV1 {
  return {
    suggestionSummary: 'AI draft suggestion: rename task task_confirm_arrival',
    semanticDiff: {
      field: 'tasks.task_confirm_arrival.name',
      from: 'Confirm arrival',
      to: 'Confirm arrival (AI draft suggestion)',
    },
    validationNote: 'Publish remains a separate human action; AI cannot publish',
    acceptIntoDraftAllowed: true,
    rejectAllowed: true,
    publishRemainsSeparate: true,
    uiState: 'executed',
    grantsAuthority: false,
  };
}
